import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import { ReactComponent as StarActive } from 'assets/icons/starActive.svg';
import { useTranslation } from 'localization';

import BorderedBox from '../../../ProfileTab/components/BorderedBox';

const LevelRequirements: React.FC<{
  title: string | undefined;
  requirement: string;
}> = ({ title, requirement }) => {
  const { t } = useTranslation('component.settings.verification');

  if (!title) {
    return null;
  }

  const body = requirement?.trim() !== '' ? requirement : t('noRequirements');

  return (
    <BorderedBox
      title={t('requirementsSectionTitle', { level: title })}
      w="100%"
    >
      <HStack align="flex-start" gap={3} w="100%">
        <Box flexShrink={0} pt={0.5} lineHeight={0}>
          <StarActive />
        </Box>
        <Text fontSize="sm" color="body" wordBreak="break-word" flex="1">
          {body}
        </Text>
      </HStack>
    </BorderedBox>
  );
};

export default LevelRequirements;
